<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M7 2.666h11v5a3.667 3.667 0 003.666 3.667h5v3.213A9.963 9.963 0 0020 12c-5.523 0-10 4.477-10 10a9.973 9.973 0 003.2 7.333H7c-.92 0-1.667-.746-1.667-1.667V4.333c0-.92.746-1.667 1.667-1.667z"/><path d="M20 7.666c0 .92.746 1.667 1.666 1.667h5L20 2.666v5z"/><path fill-rule="evenodd" d="M20 30a8 8 0 100-16 8 8 0 000 16zm0-2a6 6 0 100-12 6 6 0 000 12z" clip-rule="evenodd"/><path d="M18.816 23.22a.923.923 0 01-.2-.298.922.922 0 01-.116-.449v-3.549a.924.924 0 111.849 0v3.214l2.284 2.284a.925.925 0 01-1.308 1.307l-2.509-2.509z"/></svg>
</template>

<script>
export default {
  name: 'filesHistoryFilled'
}
</script>
